<div class="fishing-container">
  <!-- Unified Top Header: Trip Control, Status, and Utilities -->
  <div class="header-section glass-panel">
    
    <!-- Primary Start/Stop Action -->
    <button 
      mat-flat-button 
      class="main-action-btn"
      [ngClass]="isActive ? 'stop-trip' : 'start-trip'"
      (click)="toggleTrip()">
      {{ isActive ? 'STOP' : 'START' }}
    </button>

    <!-- Context & Controls (Only show when active) -->
    <div class="top-controls" *ngIf="isActive">
      
      <!-- Condensed Trip ID Status -->
      <div class="status-indicator">
        <span class="status-value">ID: {{ tripId }}</span>
      </div>

      <!-- Centered weather data -->
      <div class="weather-bar" *ngIf="currentWeather && currentTide">
        {{currentWeather.short_forecast}} | {{currentWeather.wind_direction}} {{currentWeather.wind_speed}} <br>
        {{currentTide.current_tide_cycle}} | Next: {{formattedTideTime}}
      </div>

      <!-- Toggles & Location Tracking Data -->
      <div class="utility-group">
        
        <div class="toggle-controls">
          <button mat-stroked-button class="utility-button" [ngClass]="{'inactive-toggle': !locationTrackingEnabled}" (click)="toggleLocationTracking()">
            LOC
          </button>
          <button mat-stroked-button class="utility-button" [ngClass]="{'inactive-toggle': !wakeLockEnabled}" (click)="toggleWakeLock()">
            SCR
          </button>
        </div>
        
        <div class="location-info" *ngIf="lastLocationUpdate">
          <span>Updates: {{locationUpdateCount}}</span>
          <span>Last sync: {{lastLocationUpdate | date:'shortTime'}}</span>
        </div>

      </div>

    </div>
  </div>

  <!-- Main Action Area: Catching Fish -->
  <div class="catches-section glass-panel" *ngIf="isActive">
    <app-fish-catch-button
      *ngFor="let fish of allFishTypes"
      [fishType]="fish.fish_name"
      [isActive]="isActive"
      [tripId]="tripId"
    >
    </app-fish-catch-button>
  </div>

</div>
